import styled from 'styled-components';
import Breakpoints from 'theme/Breakpoints';

export const WhatsAppFloatingButton = styled.a`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25d366;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  svg {
    width: 34px;
    height: 34px;
    fill: #ffffff;
  }

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    right: 16px;
    bottom: 16px;
    width: 52px;
    height: 52px;

    svg {
      width: 30px;
      height: 30px;
    }
  }
`;
